import router from '@/router';
import axios, { InternalAxiosRequestConfig, AxiosResponse, Axios } from 'axios';
import { ElMessage } from 'element-plus';
import store from 'store'

export const request = axios.create({
  baseURL: '/api/',
  timeout: 10000, // 设置请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
}) as Axios;

// 添加请求拦截器
request.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // 在发送请求之前做些什么
    // 在请求头中添加 token
    config.headers.Authorization = store.get('token');
    return config;
  },
  (error: any) => {
    // 处理请求错误
    console.error('请求错误', error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    // 对响应数据做些什么
    // 例如，可以检查返回的状态码，并在需要时抛出错误
    if (response.status !== 200) {
      throw new Error(`${response.status}`);
    }
    return response.data;
  },
  (error) => {
    if (error?.response?.status === 401) {
      router.push('/login')
      return Promise.reject(error);
    }
    if (error?.response?.status === 403) {
      ElMessage.error('无访问权限');
      return Promise.reject(error);
    }

    // 处理响应错误
    ElMessage.error(`返回错误：${error?.response?.data?.message}`);
    return Promise.reject(error);
  }
);
